var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CUSTOMER_GROUP_NAME, isNewCustomersGroup, isServiceCustomersGroup, isBarberCustomersGroup, isShopCustomersGroup, } from '../../../../types/engage-campaign';
import { buildInitialState } from '../store/initial-state';
import { getEditableField } from '../store/selectors';
export var buildApiPayloadAudiencesFromStore = function (params) {
    var state = params.store.getState();
    var payloadAudiences = [];
    var usesCustomAudiences = getEditableField(state, 'usesCustomAudiences').value;
    if (usesCustomAudiences) {
        var audienceFields = getEditableField(state, 'audiences').value;
        var isLapsingEnabled = audienceFields.lapsing.enabled;
        if (isLapsingEnabled) {
            payloadAudiences.push({
                name: CUSTOMER_GROUP_NAME.lapsing,
            });
        }
        var isProspectiveEnabled = audienceFields.prospective.enabled;
        if (isProspectiveEnabled) {
            payloadAudiences.push({
                name: CUSTOMER_GROUP_NAME.prospective,
            });
        }
        var isRegularEnabled = audienceFields.regular.enabled;
        if (isRegularEnabled) {
            payloadAudiences.push({
                name: CUSTOMER_GROUP_NAME.regular,
            });
        }
        var isServiceEnabled = audienceFields.service.enabled;
        if (isServiceEnabled) {
            payloadAudiences.push({
                name: CUSTOMER_GROUP_NAME.service,
                serviceId: audienceFields.service.serviceId,
            });
        }
        var _a = audienceFields.newClients, enabled = _a.enabled, weeks = _a.weeks;
        if (enabled) {
            payloadAudiences.push(__assign({ name: CUSTOMER_GROUP_NAME.new }, (weeks ? { weeks: weeks } : {})));
        }
        var isAtLeastOneBarberAudienceEnabled = Object.values(audienceFields.barbers).some(function (value) { return value.enabled; });
        if (isAtLeastOneBarberAudienceEnabled) {
            var enabledBarbers = Object.entries(audienceFields.barbers).filter(function (_a) {
                var value = _a[1];
                return value.enabled;
            });
            enabledBarbers.forEach(function (_a) {
                var barberId = _a[0];
                payloadAudiences.push({
                    name: CUSTOMER_GROUP_NAME.barber,
                    barberId: barberId,
                });
            });
        }
        var isAtLeastOneShopAudienceEnabled = Object.values(audienceFields.shops).some(function (shop) { return shop.enabled; });
        if (isAtLeastOneShopAudienceEnabled) {
            var enabledShops = Object.entries(audienceFields.shops).filter(function (_a) {
                var value = _a[1];
                return value.enabled;
            });
            enabledShops.forEach(function (_a) {
                var shopId = _a[0];
                payloadAudiences.push({
                    name: CUSTOMER_GROUP_NAME.shop,
                    shopId: shopId,
                });
            });
        }
    }
    else {
        payloadAudiences.push({
            name: CUSTOMER_GROUP_NAME.all,
        });
    }
    return { customerGroups: payloadAudiences };
};
export var buildStoreAudiencesFromApiCampaign = function (_a) {
    var _b;
    var campaign = _a.campaign, session = _a.session;
    var customerGroups = campaign.customerGroups;
    var initialState = buildInitialState({ session: session });
    var usesCustomAudiences = !customerGroups.some(function (group) { return group.name === 'all'; }) || !customerGroups.length;
    if (!usesCustomAudiences) {
        return {
            usesCustomAudiences: { value: false },
            audiences: initialState.editableFields.audiences,
        };
    }
    var newClientsAudience = customerGroups.find(isNewCustomersGroup);
    var serviceAudience = customerGroups.find(isServiceCustomersGroup);
    var lapsingAudience = customerGroups.find(function (group) { return group.name === 'lapsing'; });
    var regularAudience = customerGroups.find(function (group) { return group.name === 'regular'; });
    var prospectiveAudience = customerGroups.find(function (group) { return group.name === 'prospective'; });
    var barberAudiences = customerGroups.filter(isBarberCustomersGroup);
    var shopAudiences = customerGroups.filter(isShopCustomersGroup);
    var audiences = {
        newClients: __assign({ enabled: !!newClientsAudience }, ((newClientsAudience === null || newClientsAudience === void 0 ? void 0 : newClientsAudience.weeks) ? { weeks: newClientsAudience === null || newClientsAudience === void 0 ? void 0 : newClientsAudience.weeks } : {})),
        service: {
            enabled: !!serviceAudience,
            serviceId: (_b = serviceAudience === null || serviceAudience === void 0 ? void 0 : serviceAudience.serviceId) !== null && _b !== void 0 ? _b : null,
        },
        lapsing: {
            enabled: !!lapsingAudience,
        },
        regular: {
            enabled: !!regularAudience,
        },
        prospective: {
            enabled: !!prospectiveAudience,
        },
        barbers: {},
        shops: {},
    };
    barberAudiences.forEach(function (group) {
        audiences.barbers[group.barberId] = {
            enabled: true,
        };
    });
    shopAudiences.forEach(function (group) {
        audiences.shops[group.shopId] = {
            enabled: true,
        };
    });
    return {
        usesCustomAudiences: { value: true },
        audiences: { value: audiences },
    };
};
